import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { TReportingPaymentsReqParams, TReportingPaymentsResData } from '../types/reporting.types';

export const useGetReportingPaymentsQuery = (
  counterpartyGUID: string,
  params: TReportingPaymentsReqParams = {},
  options?: any,
): UseQueryResult<TReportingPaymentsResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReportingPaymentsQueryKeys].getPayments_MultiRole(counterpartyGUID, params),
    ...options,
  });

export const useGetReportingPaymentsDetailsQuery = (
  counterpartyGUID: string,
  params: TReportingPaymentsReqParams = {},
  options?: any,
): UseQueryResult<TReportingPaymentsResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReportingPaymentsQueryKeys].getPayments(counterpartyGUID, params),
    ...options,
  });
